import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { KYCMerchantList } from "ui/organizms/Merchants/KYC";

const KYCMerchantListScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Merchants | KYC Settings'
    >
        <KYCMerchantList />
    </Screen>
);

export default memo(KYCMerchantListScreen);
